import { SOCIAL_PLATFORMS } from 'ui-components';
import { Creator } from '~/clientApi/creator.model';
import { FEATURE_FLAGS, PARTIALLY_SUPPORTED_PLATFORMS } from '~/constants';
import { IGInsights } from '~/hooks/api/insights/useGetIGInsights';
import { SnapchatInsights } from '~/hooks/api/insights/useGetSnapchatInsights';
import { TTInsights } from '~/hooks/api/insights/useGetTTInsights';
import { YTInsights } from '~/hooks/api/insights/useGetYTInsights';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

import { PlatformChartsCaptionLastUpdatedText } from './PlatformChartsCaptionLastUpdatedText';
import { PlatformChartsCaptionLastUpdatedWithReconnectText } from './PlatformChartsCaptionLastUpdatedWithReconnectText';
import { PlatformChartsCaptionSTMPredictionText } from './PlatformChartsCaptionSTMPredictionText';
import { getIsEmptyData } from './utils';

export function PlatformChartsCaption({
  creator,
  insights,
  platform,
  connectionStatus,
}: {
  creator?: Creator;
  insights?: IGInsights | TTInsights | YTInsights | SnapchatInsights;
  platform: SOCIAL_PLATFORMS | PARTIALLY_SUPPORTED_PLATFORMS;
  connectionStatus?: string;
}) {
  const foamSmartTalentMetricsFeatureFlag = useFeature(
    FEATURE_FLAGS.foamSmartTalentMetrics,
  );

  let demographicsSource;

  if (platform === SOCIAL_PLATFORMS.youtube) {
    demographicsSource = creator?.ytChannels[0]?.demographicsSource;
  } else {
    demographicsSource = (insights as IGInsights | TTInsights)
      ?.demographicsSource;
  }

  const isSTMPrediction = demographicsSource === 'stm-predictions';

  const isEmpty = getIsEmptyData(insights);

  return (
    <>
      {!isEmpty && connectionStatus === 'connected' && !isSTMPrediction ? (
        <PlatformChartsCaptionLastUpdatedText
          demographicsLastUpdatedAt={insights?.demographicsLastUpdatedAt}
        />
      ) : null}
      {connectionStatus === 'disconnected' &&
      !foamSmartTalentMetricsFeatureFlag.isEnabled ? (
        <PlatformChartsCaptionLastUpdatedText
          demographicsLastUpdatedAt={insights?.demographicsLastUpdatedAt}
        />
      ) : null}
      {connectionStatus === 'disconnected' &&
      foamSmartTalentMetricsFeatureFlag.isEnabled &&
      !isSTMPrediction ? (
        <PlatformChartsCaptionLastUpdatedWithReconnectText
          demographicsLastUpdatedAt={insights?.demographicsLastUpdatedAt}
        />
      ) : null}
      {isSTMPrediction && foamSmartTalentMetricsFeatureFlag.isEnabled ? (
        <PlatformChartsCaptionSTMPredictionText creator={creator} />
      ) : null}
    </>
  );
}
